module.exports = __webpack_public_path__ + "img/message_icon.9517b182.svg";